import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ServicePage } from 'src/types/services';

import { API } from ':api';
import { SERVICES_PAGE } from ':api/urls';
import { HARD_CODE_PATHS } from ':constants';

/**
 * @param url если параметр будет undefined запрос не будет выполнен
 */
export const useServicesApi = (
  url: string | undefined,
): UseQueryResult<ServicePage> =>
  useQuery<ServicePage>({
    queryKey: ['Services', url],
    enabled: Boolean(url),
    queryFn: async () => {
      if (url && url in HARD_CODE_PATHS) {
        return HARD_CODE_PATHS[url];
      }

      return (await API.get(`${SERVICES_PAGE}?url=${url}`)).data;
    },
  });
